import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-bigcommerce-install-app',
  template: require('./bigcommerce_install_app.component.html'),
  styles: [require('./bigcommerce_install_app.component.scss')]

})

export class BigcommerceInstallAppComponent extends AccordionContentComponent {

}
